import { render, staticRenderFns } from "./CmsRegistObstaclePre.vue?vue&type=template&id=c5fa2f06&scoped=true&"
import script from "./CmsRegistObstaclePre.vue?vue&type=script&lang=js&"
export * from "./CmsRegistObstaclePre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5fa2f06",
  null
  
)

export default component.exports